import { toggleHighlightColorScheme } from './color-scheme';
import { classNames, elements } from './init';

const scrollCallback = () => {
	// Adds a class to differ between nav and background
	if (window.scrollY > 0) {
		elements.nav.classList.add(classNames.bg);
	} else if (!elements.body.classList.contains(classNames.stageOpen)) {
		elements.nav.classList.remove(classNames.bg);
	}
	toggleHighlightColorScheme();
};

export const initScrollEvents = () => {
	['scroll', 'DOMContentLoaded', 'resize'].forEach((type) => {
		window.addEventListener(type, () => {
			scrollCallback();
		});
	});
};
